<template>
  <div class="content">
    <!-- 页面标题 -->
    <div
      v-wechat-title="'《新仙剑奇侠传之挥剑问情》新生服10月31日盛大开启'"
    ></div>
    <!-- 移动端 -->
    <div id="main-mobile-xsf" v-if="match === 'mobile'" ref="mobile">
      <!-- 头部 -->
      <div class="header">
        <div class="user">
          {{ user_account ? user_account : "新生服盛大开启" }}
        </div>
        <div
          class="login-btn"
          v-show="!user_account"
          @click="changeLoginPopup(true)"
        ></div>
        <div class="logout-btn" v-show="user_account" @click="osCancel()"></div>
        <div class="official-btn" @click="goDownload('头部下载按钮')"></div>
      </div>

      <!-- 侧栏 -->
      <div class="aside">
        <div :class="isOpenServer ? 'asideLine1' : 'asideLine'"></div>
        <div
          :class="['item', 'one', asideIndex === 0 ? 'active' : '']"
          @click="handleScroll(0)"
        ></div>
        <div
          :class="['item', 'two', asideIndex === 1 ? 'active' : '']"
          @click="handleScroll(1)"
          v-if="!isOpenServer"
        ></div>
        <div
          :class="['item', 'three', asideIndex === 2 ? 'active' : '']"
          @click="handleScroll(2)"
        ></div>
        <div
          :class="['item', 'four', asideIndex === 3 ? 'active' : '']"
          @click="handleScroll(3)"
        ></div>
        <div
          :class="['item', 'five', asideIndex === 4 ? 'active' : '']"
          @click="handleScroll(4)"
        ></div>
      </div>

      <!-- 加入qq群 -->
      <div class="qqGroup" @click="onQqClick"></div>

      <!-- 首页 -->
      <div class="content_01">
        <div class="slogan"></div>
      </div>

      <div class="download_bg" v-if="isOpenServer">
        <div class="downloadBtn" @click="goDownload('下载按钮')"></div>
      </div>

      <!-- 预约里程碑 -->
      <div class="content_02" v-if="!isOpenServer">
        <div class="title"></div>
        <div class="main">
          <div class="item one" v-show="person >= 2000"></div>
          <div class="item two" v-show="person >= 5000"></div>
          <div class="item three" v-show="person >= 10000"></div>
        </div>
        <div class="text">
          <div class="left"></div>
          <div class="right">{{ person }}</div>
        </div>
        <div
          :class="[isReservation ? 'downloadBtn' : 'bookBtn']"
          @click="bookClick"
        ></div>
      </div>

      <!-- 分享有礼 -->
      <div
        class="content_03"
        :style="isOpenServer ? 'margin-top: -3.6rem;' : 'margin-top: 0;'"
      >
        <div class="title"></div>
        <div class="reward">
          <div class="hasAward1" v-if="cdk && isShare"></div>
          <div class="hasAward2" v-if="cdk && isShare"></div>
        </div>
        <div
          :class="[cdk ? 'lookBtn' : isShare ? 'getBtn' : 'shareBtn']"
          @click="shareClick"
        ></div>
      </div>

      <!-- 新生资讯 -->
      <div class="content_04">
        <div class="title"></div>
        <div class="main">
          <div v-for="i in 5" :key="i" class="item">
            <div :class="'itemTitle' + i" @click="itemIndexChange(i)"></div>
            <div
              :class="'itemDetail' + i + ' animated fadeIn'"
              v-show="itemIndex === i"
            ></div>
          </div>
        </div>
      </div>

      <!-- 游戏特色 -->
      <div class="content_05">
        <div class="title"></div>
        <div class="swiper1">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img
                src="../../../../assets/images/active/hjwq/refluxCustomer/swiper_01.png"
              />
            </div>
            <div class="swiper-slide">
              <img
                src="../../../../assets/images/active/hjwq/refluxCustomer/swiper_02.png"
              />
            </div>
            <div class="swiper-slide">
              <img
                src="../../../../assets/images/active/hjwq/refluxCustomer/swiper_03.png"
              />
            </div>
            <div class="swiper-slide">
              <img
                src="../../../../assets/images/active/hjwq/refluxCustomer/swiper_04.png"
              />
            </div>
            <div class="swiper-slide">
              <img
                src="../../../../assets/images/active/hjwq/refluxCustomer/swiper_05.png"
              />
            </div>
            <div class="swiper-slide">
              <img
                src="../../../../assets/images/active/hjwq/refluxCustomer/swiper_06.png"
              />
            </div>
            <div class="swiper-slide">
              <img
                src="../../../../assets/images/active/hjwq/refluxCustomer/swiper_07.png"
              />
            </div>
            <div class="swiper-slide">
              <img
                src="../../../../assets/images/active/hjwq/refluxCustomer/swiper_08.png"
              />
            </div>
          </div>
        </div>
        <div class="swiper-prev-btn"></div>
        <div class="swiper-next-btn"></div>
        <!-- <div class="swiper-pagination"></div> -->
      </div>

      <Footer :gameName="gameName"></Footer>

      <!-- 弹窗 -->
      <div class="popupWrap">
        <!-- 分享 -->
        <div
          :class="'popup share ' + share"
          @click.self="showPopup('share', false)"
        >
          <div class="main">
            <div
              class="clipboard-btn"
              @click="copyLink('.clipboard-btn')"
              data-event="复制活动链接"
              :data-clipboard-text="
                '《新仙剑奇侠传之挥剑问情》新生服10月31日8:00盛大开启，老服返利、380抽福利、十倍绑玉等你拿，欢迎大侠回家：' +
                shareLink
              "
            ></div>
          </div>
        </div>

        <!-- 预约成功 -->
        <div
          :class="'popup prebook ' + prebook"
          @click.self="showPopup('prebook', false)"
        >
          <div class="main">
            <div class="confirm-btn" @click="showPopup('prebook', false)"></div>
            <div class="qq-btn" @click="onQqClick"></div>
          </div>
        </div>

        <!-- 获取cdk -->
        <div
          :class="'popup getCdk ' + getCdk"
          @click.self="showPopup('getCdk', false)"
        >
          <div class="main">
            <input type="text" v-model="cdk" disabled />
            <div
              class="clipboard-cdk-btn"
              @click="copyLink('.clipboard-cdk-btn')"
              data-event="复制活动链接"
              :data-clipboard-text="cdk"
            ></div>
          </div>
        </div>

        <!-- 复制QQ群号码 -->
        <div
          :class="'popup qqnum ' + qqnum"
          @click.self="showPopup('qqnum', false)"
        >
          <div class="main">
            <div
              class="clipboard-qq-btn"
              @click="copyLink('.clipboard-qq-btn')"
              data-event="复制活动链接"
              :data-clipboard-text="'603243119'"
            ></div>
          </div>
        </div>

        <!-- 加入QQ群 -->
        <div
          :class="'popup qqCode ' + qqCode"
          @click.self="showPopup('qqCode', false)"
        >
          <div class="main">
            <img
              src="../../../../assets/images/active/hjwq/refluxCustomer/popup/code.png"
              alt=""
            />
          </div>
        </div>

        <!-- 下载遮罩-微信内 -->
        <div
          :class="'popup wxdownload ' + wxdownload"
          @click.self="showPopup('wxdownload', false)"
        >
          <div class="main" @click.self="showPopup('wxdownload', false)"></div>
        </div>
      </div>

      <!-- 防抖 -->
      <div class="prevent" v-show="isPrevent"></div>

      <!-- 登录弹窗 -->
      <Login
        v-if="isShowLogin"
        :gameName="gameName"
        :loginTypes="loginTypes"
        :downloadUrl="downloadUrl"
        v-on:selectCallback="selectCallback"
        channelTips="角色UID可在游戏中—头像—ID查看"
        :autoOpenOS="false"
      ></Login>
    </div>

    <!-- pc端 -->
    <div id="main-pc" v-if="match === 'pc'" style="max-width: 1920px">
      <div class="slogan"></div>
      <div class="code"></div>
    </div>
  </div>
</template>

<script>
import {
  onInitAPI,
  onOldClickAPI,
  onShareAPI,
  onCdkAPI,
  onLoginAPI,
  onLogoutAPI,
} from "../api";
import { Toast, Indicator } from "mint-ui";
import { getTimeStamp, buriedLogger } from "@/utils/utils";
import Clipboard from "clipboard";
import { mapState, mapMutations, mapActions } from "vuex";
import Login from "@/components/login";
import Footer from "@/components/Footer";
import { swiper } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  name: "refluxCustomer",
  components: {
    swiper,
    Login,
    Footer,
  },
  data() {
    return {
      gameName: "hjwq",
      loginTypes: ["sms", "password"],
      downloadUrl: "https://hjwq.qingcijoy.com/",
      logger: null,
      match: "", // 设备
      asideIndex: 0, // 侧栏索引
      swiperIndex: 0, // 轮播图active索引
      isIos: false, // ios判断
      isWechat: true, // 微信判断
      isOpenServer: false, // 是否开服

      share: false, // 分享弹窗
      prebook: false, // 预约成功弹窗
      getCdk: false, // 获取cdk
      qqnum: false, // 复制QQ群号码
      qqCode: false, // 加入QQ群
      wxdownload: false, // 下载遮罩-微信内
      cdk: "", // cdk
      isReservation: false, // 是否预约
      isShare: false, // 是否分享
      isPrevent: false, // 防抖
      person: "？？？", // 预约人数
      itemIndex: 1, // 新生咨询索引

      shareLink: "https://h5.qingcigame.com/hjwq/refluxCustomer/enter", // 分享链接
      user_account: null,
    };
  },
  computed: {
    ...mapState(["userInfo", "activeInfo", "isShowLogin"]),
  },
  created() {
    // 判断是否开服
    this.isOpenServer =
      new Date().getTime() >= new Date("2024/10/31 08:00:00").getTime();
    // 设备判断 & 自适应
    window.addEventListener("pageshow", this.resize);
    window.addEventListener("resize", this.resize);
    this.isIos = navigator.userAgent.match(/(iPhone|iPod|ios)/i);
    if (navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1) {
      this.isWechat = true;
    } else {
      this.isWechat = false;
    }

    // 免密登录
    if (this.$route.query.token) {
      onLoginAPI({ token: this.$route.query.token })
        .then((response) => {
          if (Number(response.code) === 200) {
            return (window.location.href = window.location.href.split("?")[0]);
          } else {
            this.onToast(response.message);
          }
        })
        .catch(() => {
          this.onToast("服务器出错啦");
        });
    }
    this.shareLink = `https://h5.qingcigame.com/hjwq/refluxCustomer/enter${getTimeStamp()}`;

    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();

    // 埋点
    const bl = buriedLogger("hjwq", "挥剑问情_老兵服回流用户预约活动");
    this.logger = bl;
    setTimeout(() => {
      this.logger.sum("挥剑问情_老兵服回流用户预约活动");
    }, 200);
    this.onInit();
    this.isSetShare();
  },
  watch: {},
  methods: {
    // 设备判断 & 自适应
    resize() {
      this.match = navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)
        ? "mobile"
        : "pc";
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (this.match === "pc") {
          // pc端
          let fontSize;
          if (window.innerWidth > 1920) {
            fontSize = "75px";
          } else if (window.innerWidth < 1200) {
            fontSize = (75 / 1920) * 1200 + "px";
          } else {
            fontSize = (75 / 1920) * window.innerWidth + "px";
          }
          document.getElementsByTagName("html")[0].style.fontSize = fontSize;
        } else if (this.match === "mobile") {
          // 移动端
          this.swiper1 ? this.swiper1.init() : this.swiperInit();
          this.$refs.mobile.addEventListener("scroll", this.onScroll);
        }
      }, 320);
    },
    // 初始化
    onInit() {
      onInitAPI({}).then((response) => {
        if (Number(response.code) === 200) {
          this.user_account = response.data.userinfo.account;
          this.cdk = response.data.activity.cdk;
          this.isReservation = response.data.activity.is_reservation;
          this.isShare = response.data.activity.is_share;
          this.person = response.data.activity.number;
          return;
        }
      });
    },
    // 顶部下载按钮事件
    goDownload(name) {
      this.logger.sum(`挥剑问情_老兵服回流用户预约活动_${name}`);
      if (this.isWechat) {
        return this.showPopup("wxdownload", true);
      }
      const appurl = this.isIos
        ? "https://apps.apple.com/cn/app/%E6%96%B0%E4%BB%99%E5%89%91%E5%A5%87%E4%BE%A0%E4%BC%A0%E4%B9%8B%E6%8C%A5%E5%89%91%E9%97%AE%E6%83%85-%E5%91%A8%E5%B9%B4%E5%BA%86/id6447745041"
        : "https://download4.qcplay.com/apk-v2/qc-kol-1155838.apk";
      return (window.location.href = appurl);
    },
    // 预约点击事件
    bookClick() {
      if (!this.user_account) {
        return this.changeLoginPopup(true);
      }
      if (this.isReservation) {
        this.logger.sum("挥剑问情_老兵服回流用户预约活动_立即下载按钮");
        if (this.isWechat) {
          return this.showPopup("wxdownload", true);
        }
        const appurl = this.isIos
          ? "https://apps.apple.com/cn/app/%E6%96%B0%E4%BB%99%E5%89%91%E5%A5%87%E4%BE%A0%E4%BC%A0%E4%B9%8B%E6%8C%A5%E5%89%91%E9%97%AE%E6%83%85-%E5%91%A8%E5%B9%B4%E5%BA%86/id6447745041"
          : "https://download4.qcplay.com/apk-v2/qc-kol-1155838.apk";
        return (window.location.href = appurl);
      }
      this.onReserved();
    },
    // 点击预约
    onReserved() {
      onOldClickAPI({}).then((response) => {
        if (Number(response.code) === 200) {
          this.onInit();
          this.showPopup("prebook", true);
          this.logger.sum("挥剑问情_老兵服回流用户预约活动_立即预约按钮");
          return this.onToast("预约成功");
        }
        this.onToast(response.message);
      });
    },
    // 分享点击事件
    shareClick() {
      if (!this.user_account) {
        return this.changeLoginPopup(true);
      }
      if (this.cdk) {
        this.logger.sum("挥剑问情_老兵服回流用户预约活动_查看礼包码弹窗");
        this.showPopup("getCdk", true);
      } else if (!this.isShare) {
        this.logger.sum("挥剑问情_老兵服回流用户预约活动_点击立即分享");
        this.showPopup("share", true);
      } else {
        this.onCdkClick();
      }
    },
    // 分享
    onShareClick() {
      if (this.isShare) {
        return;
      }
      onShareAPI({}).then((response) => {
        if (Number(response.code) === 200) {
          this.onInit();
          this.logger.sum("挥剑问情_老兵服回流用户预约活动_复制链接");
          return;
        }
        this.onToast(response.message);
      });
    },
    // 领取cdk
    onCdkClick() {
      if (this.cdk) {
        return;
      }
      onCdkAPI({}).then((response) => {
        if (Number(response.code) === 200) {
          this.onToast("领取成功");
          this.onInit();
          this.showPopup("getCdk", true);
          this.logger.sum("挥剑问情_老兵服回流用户预约活动_领取cdk");
          return;
        }
        this.onToast(response.message);
      });
    },
    // 加入qq群
    onQqClick() {
      this.logger.sum("挥剑问情_老兵服回流用户预约活动_打开加入备战群弹窗");
      this.showPopup("prebook", false);
      if (this.isWechat) {
        this.showPopup("qqnum", true);
      } else {
        window.location.href =
          "http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=9m3q3HCM66zG1wa4i7zTNU5SvmEoaUS3&authKey=chCdtXP3YI9EcpRdHTGi5Arb9o%2F2UCraObhgrVJMI20hjktypzscmNxu14FuFBOK&noverify=0&group_code=603243119";
      }
    },
    // 新生资讯切换
    itemIndexChange(index) {
      this.itemIndex = index;
    },
    // 侧栏监听滚动
    onScroll(e) {
      if (this.timer2) clearTimeout(this.timer2);
      this.timer2 = setTimeout(() => {
        const scrollTop = e.target.scrollTop;
        const header =
          document.getElementsByClassName("header")[0].clientHeight;
        const two = !this.isOpenServer
          ? document.getElementsByClassName("content_02")[0].offsetTop
          : 0;
        const three =
          document.getElementsByClassName("content_03")[0].offsetTop;
        const four = document.getElementsByClassName("content_04")[0].offsetTop;
        const five = document.getElementsByClassName("content_05")[0].offsetTop;
        if (scrollTop >= five - header) {
          this.asideIndex = 4;
        } else if (scrollTop >= four - header) {
          this.asideIndex = 3;
        } else if (scrollTop >= three - header) {
          this.asideIndex = 2;
        } else if (scrollTop >= two - header && !this.isOpenServer) {
          this.asideIndex = 1;
        } else {
          this.asideIndex = 0;
        }
      }, 50);
    },
    // 侧栏点击滚动
    handleScroll(index) {
      this.asideIndex = index;
      const top =
        document.getElementsByClassName(`content_0${index + 1}`)[0].offsetTop -
        document.getElementsByClassName("header")[0].clientHeight;
      document
        .getElementById("main-mobile-xsf")
        .scrollTo({ top, behavior: "smooth" });
    },
    // 轮播图初始化
    swiperInit() {
      let that = this;
      setTimeout(() => {
        this.swiper1 = new Swiper(".swiper1", {
          loop: true,
          autoplay: 5000,
          direction: "vertical",
          autoplayDisableOnInteraction: false,
          slidesPerView: "auto",
          centeredSlides: true,
          allowTouchMove: false,
          effect: "coverflow",
          coverflow: {
            rotate: 0,
            stretch: 110,
            slideShadows: false,
          },
          onSlideChangeStart: function () {
            // that.swiperIndex = that.swiper1 ? that.swiper1.realIndex : 0;
          },
          prevButton: ".swiper-prev-btn",
          nextButton: ".swiper-next-btn",
          // pagination: ".swiper-pagination",
          // paginationClickable: true,
        });
      }, 200);
    },
    // 打开 || 关闭弹窗
    showPopup(name, boolean) {
      switch (name) {
        case "share":
          if (!this.user_account) {
            this.changeLoginPopup(true);
            this.onToast("请先登录");
            return;
          }
          this.share = boolean;
          break;
        case "prebook":
          this.prebook = boolean;
          break;
        case "getCdk":
          if (!this.user_account) {
            this.changeLoginPopup(true);
            this.onToast("请先登录");
            return;
          }
          this.getCdk = boolean;
          break;
        case "qqnum":
          this.qqnum = boolean;
          break;
        case "qqCode":
          this.qqCode = boolean;
          break;
        case "wxdownload":
          this.wxdownload = boolean;
          break;
      }
    },
    // 复制链接
    copyLink(copyName) {
      if (!this.user_account && copyName !== ".clipboard-qq-btn") {
        this.changeLoginPopup(true);
        this.onToast("请先登录");
        return;
      }
      var _this = this;
      const clipboard = new Clipboard(copyName);
      clipboard.on("success", (e) => {
        clipboard.destroy();
        if (copyName === ".clipboard-btn") {
          window.setTimeout(() => {
            _this.onShareClick();
          }, 2000);
        } else {
          _this.logger.sum("挥剑问情_老兵服回流用户预约活动_一键复制");
        }
        _this.onToast("复制成功");
        e.clearSelection();
      });
      clipboard.on("error", (e) => {
        clipboard.destroy();
        _this.onToast("复制失败");
      });
    },
    selectCallback() {
      this.onInit();
    },
    // 区组弹窗注销
    osCancel() {
      this.user_account = null;
      window.localStorage.setItem("access_token", "");
      onLogoutAPI({
        game_id: 58,
      })
        .then((response) => {
          if (Number(response.code) === 200) {
            this.user_account = null;
            this.cdk = "";
            this.isReservation = false;
            this.isShare = false;
            this.person = "？？？";
            this.onInit();
            this.onToast("注销成功");
            return;
          }
          this.onToast(response.message);
        })
        .catch(() => {
          this.onToast("服务器出错啦");
        });
    },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: "toasts",
      };
      if (!config) {
        console.error("缺少config参数");
        return false;
      }
      if (typeof config === "string") {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    // 前往重定向
    goLink(url, loggerName) {
      if (url === "") return this.onToast("敬请期待！");
      this.logger.sum(loggerName);
      setTimeout(() => {
        window.location.href = url;
      }, 200);
    },
    // 微信分享
    isSetShare() {
      this.setShare({
        link: `https://h5.qingcigame.com/hjwq/refluxCustomer/enter${getTimeStamp()}`,
        title: "新仙剑 | 新生服盛大开启",
        imgUrl:
          "https://download4.qcplay.com/qcgame-api/OxH4R39KsdmSBJbThR1mDrTPEob1cfqVjiipgAlu.jpeg",
        desc: "10月31日8:00准时开服，老服返利、380抽福利、十倍绑玉等你拿，欢迎大侠回家！",
      });
    },
    ...mapMutations([
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
    ]),
    ...mapActions(["setShare"]),
  },
};
</script>

<style lang="less">
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/hjwq/refluxCustomer/index/index.vue